/**
 * @license
 * Copyright (c) Absa Group Limited, All Rights Reserved.
 */
import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'no-device-yet',
  encapsulation: ViewEncapsulation.Emulated,
  template: require('./no-device-yet.component.html'),
  styles: [
    `  
      .device-section {
          background-color: #fff;
          color: #504a4a;
          min-height: 390px;
          margin-top: 20px;
          padding: 0 60px;
          box-shadow: 0px 2px 6px 2px rgba(224, 223, 223, 0.4);
      }
      .no-devices-head {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 8px;
      }
      .no-devices-text-container{
        margin-top: -30px;
      }
      .txt-dowload-logon{
        padding-bottom: 10px;
        line-height: 1.3;
      }
      .mobile-devices {
          background-image: url(../../../assets/images/mobile_phones.png);
          background-size: contain;
          background-repeat: no-repeat !important;
          background-position: 120%;
          width: 100%;
          height: 390px;
      }
      .tick {
          background-image: url(../../../assets/svg/tick.svg);
          width: 25px;
          height: 25px;
          background-repeat: no-repeat;
          display: inline-block;
          background-size: contain;
          flex-shrink: 0;
      }
      .feature-item {
          display: flex;
          align-items: flex-start;
          gap: 10px;
          margin-bottom: 12px;
      }
     .link-overlay{
          position: absolute;
          top: 300px;
          left: 275px;
          width: 90px;
          height: 30px;
      }
      
     @media screen and (min-width: 1024px) and (max-width: 1279px) {
          .link-overlay{
            top:287px;
            left: 186px;
          }
      }
     @media screen and (min-width: 800px) and (max-width: 1023px) {
          .link-overlay{
            top:260px;
            left:125px;
        }
      }
    `,
  ],
})
export class NoDeviceYetComponent {
  private manualDownloadUrl: string;
  constructor() {
    this.manualDownloadUrl = `${JSON.parse(window['__CONFIGURATION'])['authUrl']}/mobile`;
  }
}




// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/manage-mfa-device/no-device-yet/no-device-yet.component.ts